export enum DropdownAvailableIconsEnum {
  homeIcon = "homeIcon",
}
